import { Link, type LinkProps } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getLocalizedPath, localizedRoutes, type RouteKey } from '@/i18n/routes'
import type { SupportedLanguage } from '@/i18n'

interface LocalizedLinkProps extends Omit<LinkProps, 'to'> {
  to: RouteKey | string
  params?: Record<string, string>
}

export function LocalizedLink({ to, params, children, ...props }: LocalizedLinkProps) {
  const { i18n } = useTranslation()
  const currentLang = i18n.language as SupportedLanguage

  let path: string

  if (to in localizedRoutes) {
    path = getLocalizedPath(to as RouteKey, currentLang, params)
  } else if (to.startsWith('/')) {
    // Absolute path - add language prefix
    path = `/${currentLang}${to}`
  } else if (to.startsWith('http') || to.startsWith('mailto:') || to.startsWith('tel:')) {
    // External link - pass through
    path = to
  } else {
    // Relative path - add language prefix
    path = `/${currentLang}/${to}`
  }

  return (
    <Link to={path} {...props}>
      {children}
    </Link>
  )
}
